// extracted by mini-css-extract-plugin
module.exports = {"chMap":"locationDepth1_chMap__1WjvL","chMapTbB":"locationDepth1_chMapTbB__M_x72"};